import * as locales from './locales'
import { indexOf, result } from 'lodash'

export default function(value, glue='\n')
{
	let countryCode = result(value, 'country_code') || result(value, 'countryCode') || result(value, 'country')

	if ( indexOf([ 'US', 'USA', 'UNITED STATES' ], ( countryCode + '' ).toUpperCase()) > -1 )
	{
		countryCode = 'US'
	}
	else if ( indexOf([ 'DK', 'DNK', 'DENMARK' ], ( countryCode + '' ).toUpperCase()) > -1 )
	{
		countryCode = 'DK'
	}

	return ( locales[countryCode] || locales.international )(value).join(glue)
}

export { locales }